export const PageNotFound = {
  errorTitle: "Page not found",
  errorMessage:
    "Review that the URL has been typed correctly. \nIf the problem persists, contact FleetOps or TAC for assistance or to report the issue.",
  image: "/assets/404Page.png",
};

export const UserNotAuthorized = {
  errorTitle: "User not authorized",
  errorMessage:
    "It looks like you do not have permission to access this application. If you believe you should have access, please contact your administrator.",
  image: "/assets/unauthorized.png",
};

export const ClockOutOfSync = {
  errorTitle: "Incorrect date and time",
  errorMessage:
    "Your device's date and time appear to be incorrect, which prevents you from signing in. \nPlease correct your device's clock (enable automatic date & time) and try again.",
  image: "/assets/unauthorized.png",
};
